<template>
  <div class="meter-device-search mt-5">
    <!-- Nouvel onboarding : les commandes d'équipement de l'organisation (la liste ci-dessous est inchangée) -->
    <organization-commissionings v-if="organization && canSeeCommissionings" :organization-id="organization.id" kind="meter-device" />
    <meter-device-list
        v-if="organization"
        :organization-id="organization.id"
    />
  </div>
</template>

<script>
import MeterDeviceList from "@/components/elements/MeterDeviceList.vue";
import OrganizationCommissionings from "@pages/Onboarding/Commissioning/OrganizationCommissionings.vue";

export default {
  components: { MeterDeviceList, OrganizationCommissionings },

  computed: {
    canSeeCommissionings() {
      const permissions = this.currentUser?.permissions || []
      return permissions.includes('COMMISSIONING_REQUEST') || permissions.includes('ONBOARDING_MODULE_MANAGE')
    },
    organization() {
      return this.$parent.organization ?? null
    },
  },
}
</script>
